<template>
  <div>
    <navMenu />

    <hero :heroTitle="$t('teachersPage.title')" class="pb-0" />

    <section class="jsk-block pt-0 pb-0">
      <div class="container">
        <div class="row">
          <div class="col-12 col-lg-8 offset-lg-2 col-md-12 text-center">
            <p class="mt-4 mb-5">{{ $t("teachersPage.subtitle") }}</p>
          </div>
        </div>
      </div>
    </section>

    <teachersCurricula 
    :teachersCurriculaHelloWorld='$t("teachersPage.curriculaHelloWorld")' 
    :teachersCurriculaHelloJavaScript='$t("teachersPage.curriculaHelloJavaScript")'
    />

    <teachersForm />

    <featured />
    <footerJSK />
  </div>
</template>

<script>
import navMenu from "./../components/navMenu.vue";
import hero from "./../components/hero.vue";
import teachersCurricula from "./../components/teachersCurricula.vue";
import teachersForm from "./../components/teachersForm.vue";
import featured from "./../components/featured.vue";
import footerJSK from "./../components/footer.vue";

export default {
  name: "Teachers",
  components: {
    navMenu,
    hero,
    teachersCurricula,
    teachersForm,
    featured,
    footerJSK
  },
  mounted () {
    window.scrollTo(0, 0)
  }
};
</script>
